(function () {
    //get the formApp module
    var formApp = angular.module('formApp');

    //set the controller to the code here - the controller uses DataServices.
    formApp.controller('investigationFormController',
        ['$scope', '$http', '$controller', 'DataServices', 'UtilityServices', 'ValidationService', '$log', '$location', '$routeParams', '$filter', '$anchorScroll', '$timeout', '$rootScope', 'Constants',
        function ($scope, $http, $controller, DataServices, UtilityServices, ValidationService, $log, $location, $routeParams, $filter, $anchorScroll, $timeout, $rootScope, Constants) {

            // Inherit parent controller
            $controller('questionController', { $scope: $scope });
            $controller('followUpController', { $scope: $scope, feedbackType: Constants.FeedbackType.Privacy, incidentId: DataServices.responseInfo.incidentId });

            // only get the config data if we don't have it
            //DataServices.getConfigurationUsingCache(Constants.ConfigTemplate.investigation, $scope.versionNumber, DataServices.isAuthenticated())
            DataServices.getConfigurationUsingCache(Constants.ConfigTemplate.investigation, $scope.versionNumber, null, true)
                .then(function (data) {
                    $scope.setupTriggersAndDynamicValues();
                    $scope.setSummaryErrorFocus();
                    $scope.isPageEditable = DataServices.isFollowUpEditable === true && $scope.page.isEditable === true;

                    document.title = $scope.utility.getPageTitle($scope.navTabNum, $scope.pageUrl);
                });

            $scope.status = DataServices.responseInfo.status;
            $scope.incidentId = DataServices.responseInfo.incidentId;
            $scope.incidentRef = DataServices.responseInfo.incidentRef;
            $scope.statusText = DataServices.responseInfo.statusText;
            $scope.template = Constants.ConfigTemplate.investigation;

            $scope.saveInvestigation = function () {
                // no validation 
                $scope.currentLoadSubmitMessage = "Saving Investigation";
                $scope.callSaveFollowUp($scope.feedbackType).then(function () {
                    // go back to co-ordination page
                    $scope.returnToCoordinationPage();
                });

            };

            $scope.submitInvestigation = function () {
                // implement submit logic
                if ($scope.validatePage($scope.navTabNum, $scope.pageUrl, null, null, null, 'inline')) {
                    $scope.currentLoadSubmitMessage = "Submitting Investigation";
                    $scope.callSubmitFollowUp($scope.feedbackType).then(function () {
                        $scope.returnToCoordinationPage();
                    });
                }
                else {
                    $scope.moveToFirstError();
                }
            };

            $scope.cancel = function () {

                $scope.callCancelFollowUp();
            };

        }]);
}());